// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__EYVAg","noInteraction":"EventWrapper_noInteraction__1pir1"};